var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenLockButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17207",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17207",
    transform: "translate(-2411 -553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17206",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17206",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15461",
    "data-name": "\\u9577\\u65B9\\u5F62 15461",
    width: 50,
    height: 50,
    rx: 8,
    transform: "translate(2414 555)",
    fill: "#393939"
  })), /*#__PURE__*/React.createElement("path", {
    id: "lock",
    d: "M22.8,12.124V9.231a7.231,7.231,0,1,0-14.463,0v2.893A4.261,4.261,0,0,0,4,16.463V26.587a4.261,4.261,0,0,0,4.339,4.339H22.8a4.261,4.261,0,0,0,4.339-4.339V16.463A4.261,4.261,0,0,0,22.8,12.124ZM11.231,9.231A4.261,4.261,0,0,1,15.57,4.893a4.261,4.261,0,0,1,4.339,4.339v2.893H11.231Zm5.785,14.463A1.366,1.366,0,0,1,15.57,25.14a1.366,1.366,0,0,1-1.446-1.446V19.355a1.366,1.366,0,0,1,1.446-1.446,1.366,1.366,0,0,1,1.446,1.446Z",
    transform: "translate(2420.43 561.537)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenLockButton);
export default __webpack_public_path__ + "static/media/tokenLockButton.4443e3ce264ee2ec9a4b9ad3172caefe.svg";
export { ForwardRef as ReactComponent };